export default __webpack_public_path__ + "static/media/pin.b4466894.svg";